import { useTranslation } from "react-i18next"

import { SectionSummary, SummaryData } from "@/app/report/common/constructor"
import { resolveDecimalPoint } from "@/app/report/common/tools"
import { useTranslateMetricKey } from "@/hooks/metric/useTranslateKeyHook"
import LoadingSpinner from "@/app/components/LoadingSpinner"

import "./dailyReportSummary.scss"

export default function DailyReportSummary({
  data,
  loading,
  decimalPlaces,
}: {
  data: SectionSummary | null
  loading: boolean
  /** 소수점 자릿수 — 없으면 1자리(정수 단위는 0). PDF 빌더 아이템 옵션 (2026-10-01 요청) */
  decimalPlaces?: number
}) {
  return (
    <div className="DailyReportSummaryCont renewal-pdf-container">
      {data?.summaries.map((item) => (
        <DailyReportSummaryItem
          key={item.metric}
          loading={loading}
          decimalPlaces={decimalPlaces}
          {...item}
        />
      ))}
    </div>
  )
}

// 기본 1자리 소수, 정수 단위(bpm)는 0자리 — 테이블과 같은 규칙 (#169 / 버그 #9)
export function formatSummaryValue(value: number, unit: string | null, decimalPlaces = 1): number {
  const decimalPoint = resolveDecimalPoint(unit, decimalPlaces)
  const factor = 10 ** decimalPoint

  return Math.round(value * factor) / factor
}

function DailyReportSummaryItem({
  metric,
  data,
  unit,
  title,
  loading,
  decimalPlaces,
}: SummaryData & { loading: boolean; decimalPlaces?: number }) {
  const { t } = useTranslation()
  const translateKey = useTranslateMetricKey()

  return (
    <div className="DailyReportSummaryItemCont">
      <p className="daily-report-summary-title">{t(title)}</p>

      <span>
        <p className="daily-report-summary-data">
          {typeof data === "number" ? formatSummaryValue(data, unit, decimalPlaces) : "-"}
        </p>
        <p className="daily-report-summary-unit">{unit || ""}</p>
      </span>
      <p className="daily-report-summary-metric">{translateKey(metric) || "-"}</p>

      {loading && (
        <div className="DailySummaryLoadingCont">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}
